import React from "react";
import styled from "styled-components";
import { Layout } from "../components/layout/Layout";
import { RegisterForm } from "../components/auth/RegisterForm";

const RegisterContainer = styled.div`
  min-height: calc(100vh - var(--spacing-4) * 2);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-4);
  background:
    linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
    url("https://images.unsplash.com/photo-1536440136628-849c177e76a1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80")
      center/cover no-repeat fixed;
`;

const Register = () => (
  <Layout>
    <RegisterContainer>
      <RegisterForm />
    </RegisterContainer>
  </Layout>
);

export default Register;
